import React, { Component } from "react";
import axios from "axios";
import Modal from "react-modal";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Link, withRouter } from "react-router-dom";
import swal from "@sweetalert/with-react";
import { Page, pdfjs } from 'react-pdf';
import { Document } from 'react-pdf/dist/entry.webpack';
import ReactToPrint from "react-to-print";

import { apiBaseUrl } from "../../api/helpers";
import "./index.scss";

class Pdf_ModalComponent extends Component {
  constructor(props) {
    super(props);
    this.documentRef = React.createRef();
    this.state = {
      publication: {},
      numPages: null,
      pageNumber: 1,
      option: "",
      isDisabled: true,
      checked: false,
    };
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }

  scrollToBottom = () => {
    this.divEnd &&
      this.divEnd.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
  };

  render() {
    const pdf_url = this.props.pdf_url
    const pdf_url_Type = this.props.pdf_url_Type
    console.log("pdf_url: ", pdf_url);

    const customStyles = {
      content: {
        top: "75px",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translateX(-50%)",
        width: "90%",
        height: "85%",
        borderWidth: 0,
      },
      overlay: {
        backgroundColor: "rgba(0,0,0,0.8)",
        zIndex: 2,
      },
    };

    const { numPages } = this.state;

    console.log("this.props.url: ", this.props.url);

    return (
      <React.Fragment>

        <Modal
          style={customStyles}
          ariaHideApp={false}
          isOpen={this.props.pdfModalIsOpen}
          onRequestClose={this.props.onClose}
        >
          <div className="container h-75">
            <React.Fragment>
              <div className="row no-gutters">
                <div className="col-12">
                  <div className="box-layout shadow-sm w-100 gray-box-border scrollable-box">
                    <div className="pdf-wrapper d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center mt-2 ml-2">
                        <span 
                          className="light-outline-btn px-2  clickable d-inline-bloc"
                          onClick={this.props.onClose}
                        >
                          x
                        </span>
                        {
                          pdf_url_Type !== "GoogleDrive"? (
                            <a  href={pdf_url} target="_blank" className="white-border bg-transparent rounded d-flex align-items-center justify-content-center p-1 clickable ml-3"
                            >
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/download.png"
                                }
                                height="30"
                                className="contain-img clickable"
                                alt=""
                              />
                            </a>
                          ):null
                        }
                        <ReactToPrint
                          trigger={() => (
                            <div className="white-border bg-transparent rounded d-flex align-items-center justify-content-center p-1 clickable ml-3">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/printer.png"
                                }
                                height="25"
                                className="contain-img clickable"
                                alt=""
                              />
                            </div>
                          )}
                          content={() => this.componentRef}
                        />
                      
                      </div>
                    </div>
                   
                    <div className="position-relative document-container">
                    
                      {pdf_url_Type == "GoogleDrive"? (
                        <iframe
                          src={pdf_url}
                          width='100%'
                          height='565px'
                          frameborder='0'
                          onContextMenu="return false;">
                        </iframe>
                      ):(
                      <Document
                        file={`${pdf_url}`}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        ref={el => (this.componentRef = el)}
                      >
                        {Array.from(new Array(numPages), (el, index) => (
                          <React.Fragment>
                            <Page key={`page_${index + 1}`} pageNumber={index + 1}>
                              <div className="watermark w-100 d-flex align-items-center justify-content-between">
                                <h6 className="mb-0 ml-2">{index + 1}</h6>
                              </div>
                            </Page>
                          </React.Fragment>
                        ))}
                      </Document>

                      )}
                    </div>
                  </div>
                </div></div>
            </React.Fragment>
          </div>
          <div
            ref={(el) => {
              this.divEnd = el;
            }}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    cart: state.cart,
  };
}

Pdf_ModalComponent = connect(mapStateToProps)(Pdf_ModalComponent);

export const PdfModal = withRouter(Pdf_ModalComponent);
